// extracted by mini-css-extract-plugin
export default {"navbar_main_header":"Navbar_navbar_main_header__FwKoI","navbar_logo":"Navbar_navbar_logo__ganQ9"};